import React from 'react';
import { useTranslate } from '../../../components/TranslationText';
import EahsForm from '../../../components/EahsForm';
/**
 * Contract acceptance section for semen checkout.
 *
 * When a signed contract file exists (edit mode), shows a checkbox
 * that reveals a "View Signed Contract" download link when checked.
 * Otherwise shows the standard "Accept Contract" checkbox with a
 * "View Contract" link.
 *
 * @param {object|null} orderDetails - Order details from API
 * @param {boolean} disabled - Disable the checkbox (view-only mode)
 */
export default function SemenContractSection({ orderDetails, disabled = false }) {
    const { translate } = useTranslate();

    return (
        <EahsForm title={translate('web.contractInvoice', 'Contract And Invoice')}>
            <div className="col-12">
                {orderDetails?.contractFile?.fileUrl && (
                    <a
                        href={`${orderDetails.contractFile.fileUrl}`}
                        target="_blank"
                        rel="noreferrer"
                        className="btn btn-outline-primary ms-4"
                        style={{ fontSize: '0.9em' }}
                    >
                        <i className="fa-solid fa-download me-2"></i>
                        {translate('web.downloadContract', 'Download Contract')}
                    </a>
                )}
                {orderDetails?.invoiceFile?.fileUrl && (
                    <a
                        href={`${orderDetails.invoiceFile.fileUrl}`}
                        target="_blank"
                        rel="noreferrer"
                        className="btn btn-outline-primary ms-4"
                        style={{ fontSize: '0.9em' }}
                    >
                        <i className="fa-solid fa-file-invoice me-2"></i>
                        {translate('web.downloadInvoice', 'Download Invoice')}
                    </a>
                )}
            </div>
        </EahsForm>
    );
}
